import { BaseService } from "./Base.Service";

export class ConfigService extends BaseService {
  constructor() {
    super({ uri: "uiconfigs" });
  }
}
